/**
 * @file: relativeTime.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * "Mail-style" time labels used in inbox rows:
 *   <1 min        → 刚刚
 *   <60 min       → N分钟前
 *   today         → HH:mm
 *   yesterday     → 昨天 HH:mm
 *   this year     → M月D日
 *   other         → YYYY/M/D
 */

export function relativeTime(input: string | Date | null | undefined): string {
  if (!input) return '';
  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return '';

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMin = Math.floor(diffMs / 60_000);

  if (diffMin < 1) return '刚刚';
  if (diffMin < 60) return `${diffMin}分钟前`;

  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  if (sameDay) return formatHm(date);

  const yest = new Date(now);
  yest.setDate(now.getDate() - 1);
  const isYesterday =
    date.getFullYear() === yest.getFullYear() &&
    date.getMonth() === yest.getMonth() &&
    date.getDate() === yest.getDate();
  if (isYesterday) return `昨天 ${formatHm(date)}`;

  if (date.getFullYear() === now.getFullYear()) {
    return `${date.getMonth() + 1}月${date.getDate()}日`;
  }
  return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
}

function formatHm(d: Date): string {
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  return `${h}:${m}`;
}
